import { booleanAttribute, Component, computed, input } from '@angular/core';

@Component({
  selector: 'app-transaction-counter',
  templateUrl: './transaction-counter.component.html',
})
export class TransactionCounterComponent {
  readonly isActive = input<boolean, unknown>(undefined, {
    transform: booleanAttribute,
  });

  transactions = input<any[]>([]);

  selectedItems = computed(() =>
    this.transactions().filter((item) => item.selected),
  );
}
